import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';
import { ArrowRight, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

interface RelatedLink {
  title: string;
  description: string;
  href: string;
  external?: boolean;
  category?: string;
}

interface RelatedLinksProps {
  title?: string;
  links: RelatedLink[];
  className?: string;
  columns?: 2 | 3 | 4;
}

const RelatedLinks = ({ 
  title = "Conteúdo Relacionado", 
  links, 
  className,
  columns = 3 
}: RelatedLinksProps) => {
  const gridClasses = {
    2: "md:grid-cols-2",
    3: "md:grid-cols-3", 
    4: "md:grid-cols-2 lg:grid-cols-4"
  };

  return (
    <div className={cn("py-16", className)}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4 fs-gradient-text">
            {title}
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto">
            Explore mais conteúdos relacionados que podem interessar você
          </p>
        </div>

        <div className={cn("grid grid-cols-1 gap-6", gridClasses[columns])}>
          {links.map((link, index) => (
            <Card 
              key={index} 
              className="bg-gray-900/50 border border-border hover:border-fs-purple-500/40 transition-all duration-300 group hover:-translate-y-1"
            >
              <CardContent className="p-6">
                {link.category && (
                  <div className="text-fs-cyan-400 text-xs font-medium uppercase tracking-wide mb-2">
                    {link.category}
                  </div>
                )}
                
                <h3 className="text-lg font-semibold text-white mb-3 group-hover:fs-gradient-text transition-all duration-300">
                  {link.title}
                </h3>
                
                <p className="text-white/70 text-sm mb-4 leading-relaxed">
                  {link.description}
                </p>
                
                {link.external ? (
                  <a 
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-fs-purple-500 hover:text-fs-cyan-500 transition-colors text-sm font-medium"
                  >
                    Saiba mais
                    <ExternalLink className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </a>
                ) : (
                  <Link 
                    to={link.href}
                    className="inline-flex items-center text-fs-purple-500 hover:text-fs-cyan-500 transition-colors text-sm font-medium"
                  >
                    Saiba mais
                    <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                  </Link>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RelatedLinks;